module.exports = __webpack_public_path__ + "static/media/YF92_4.a71d1d5f.jpg";